/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtMillingElementControllerMillingElement } from '../fn/milling-element/create-one-base-mgmt-milling-element-controller-milling-element';
import { CreateOneBaseMgmtMillingElementControllerMillingElement$Params } from '../fn/milling-element/create-one-base-mgmt-milling-element-controller-milling-element';
import { deleteOneBaseMgmtMillingElementControllerMillingElement } from '../fn/milling-element/delete-one-base-mgmt-milling-element-controller-milling-element';
import { DeleteOneBaseMgmtMillingElementControllerMillingElement$Params } from '../fn/milling-element/delete-one-base-mgmt-milling-element-controller-milling-element';
import { getManyBaseMgmtMillingElementControllerMillingElement } from '../fn/milling-element/get-many-base-mgmt-milling-element-controller-milling-element';
import { GetManyBaseMgmtMillingElementControllerMillingElement$Params } from '../fn/milling-element/get-many-base-mgmt-milling-element-controller-milling-element';
import { GetManyMillingElementResponseDto } from '../models/get-many-milling-element-response-dto';
import { getOneBaseMgmtMillingElementControllerMillingElement } from '../fn/milling-element/get-one-base-mgmt-milling-element-controller-milling-element';
import { GetOneBaseMgmtMillingElementControllerMillingElement$Params } from '../fn/milling-element/get-one-base-mgmt-milling-element-controller-milling-element';
import { MillingElement } from '../models/milling-element';
import { updateOneBaseMgmtMillingElementControllerMillingElement } from '../fn/milling-element/update-one-base-mgmt-milling-element-controller-milling-element';
import { UpdateOneBaseMgmtMillingElementControllerMillingElement$Params } from '../fn/milling-element/update-one-base-mgmt-milling-element-controller-milling-element';

@Injectable({ providedIn: 'root' })
export class MillingElementApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtMillingElementControllerMillingElement()` */
  static readonly GetManyBaseMgmtMillingElementControllerMillingElementPath = '/api/mgmt/milling-element';

  /**
   * Retrieve multiple MillingElements.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtMillingElementControllerMillingElement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtMillingElementControllerMillingElement$Response(params?: GetManyBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyMillingElementResponseDto>> {
    const obs = getManyBaseMgmtMillingElementControllerMillingElement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple MillingElements.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtMillingElementControllerMillingElement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtMillingElementControllerMillingElement(params?: GetManyBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<GetManyMillingElementResponseDto> {
    const resp = this.getManyBaseMgmtMillingElementControllerMillingElement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyMillingElementResponseDto>): GetManyMillingElementResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtMillingElementControllerMillingElement()` */
  static readonly CreateOneBaseMgmtMillingElementControllerMillingElementPath = '/api/mgmt/milling-element';

  /**
   * Create a single MillingElement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtMillingElementControllerMillingElement()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtMillingElementControllerMillingElement$Response(params: CreateOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<MillingElement>> {
    const obs = createOneBaseMgmtMillingElementControllerMillingElement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single MillingElement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtMillingElementControllerMillingElement$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtMillingElementControllerMillingElement(params: CreateOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<MillingElement> {
    const resp = this.createOneBaseMgmtMillingElementControllerMillingElement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MillingElement>): MillingElement => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtMillingElementControllerMillingElement()` */
  static readonly GetOneBaseMgmtMillingElementControllerMillingElementPath = '/api/mgmt/milling-element/{id}';

  /**
   * Retrieve a single MillingElement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtMillingElementControllerMillingElement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtMillingElementControllerMillingElement$Response(params: GetOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<MillingElement>> {
    const obs = getOneBaseMgmtMillingElementControllerMillingElement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single MillingElement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtMillingElementControllerMillingElement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtMillingElementControllerMillingElement(params: GetOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<MillingElement> {
    const resp = this.getOneBaseMgmtMillingElementControllerMillingElement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MillingElement>): MillingElement => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtMillingElementControllerMillingElement()` */
  static readonly DeleteOneBaseMgmtMillingElementControllerMillingElementPath = '/api/mgmt/milling-element/{id}';

  /**
   * Delete a single MillingElement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtMillingElementControllerMillingElement()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtMillingElementControllerMillingElement$Response(params: DeleteOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtMillingElementControllerMillingElement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single MillingElement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtMillingElementControllerMillingElement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtMillingElementControllerMillingElement(params: DeleteOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtMillingElementControllerMillingElement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtMillingElementControllerMillingElement()` */
  static readonly UpdateOneBaseMgmtMillingElementControllerMillingElementPath = '/api/mgmt/milling-element/{id}';

  /**
   * Update a single MillingElement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtMillingElementControllerMillingElement()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtMillingElementControllerMillingElement$Response(params: UpdateOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<StrictHttpResponse<MillingElement>> {
    const obs = updateOneBaseMgmtMillingElementControllerMillingElement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single MillingElement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtMillingElementControllerMillingElement$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtMillingElementControllerMillingElement(params: UpdateOneBaseMgmtMillingElementControllerMillingElement$Params, context?: HttpContext): Observable<MillingElement> {
    const resp = this.updateOneBaseMgmtMillingElementControllerMillingElement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MillingElement>): MillingElement => r.body)
    );
  }

}
